import { buryPoint } from '@/Common/plugins/buried-point';
// import {touristModePass} from '@/libs/touristModeUtils';

export default {
  identityPageShow() {
    buryPoint.event({
      action: '身份选择-出现弹窗',
      eventCategory: '身份选择'
    });
  },
  identityPageChoose(type) {
    const op = {
      1: '服务供应商',
      2: '终端用户'
    };
    buryPoint.event({
      action: '身份选择-选择',
      eventCategory: '身份选择',
      eventLabel: op[type]
    });
  },
  HPCToCompanyInfo(type) {
    const op = {
      1: '认证码必填',
      2: '认证码选填',
      3: '不需要验证码'
    };
    buryPoint.event({
      action: 'admin注册弹窗-完善公司信息',
      eventCategory: 'admin注册弹窗',
      eventLabel: op[type]
    });
  },
  HPCToPersonInfo() {
    buryPoint.event({
      action: 'admin注册弹窗-完善个人信息',
      eventCategory: 'admin注册弹窗'
    });
  },
  HPCCompleteRegister(type) {
    const op = {
      1: '认证码必填',
      2: '认证码选填',
      3: '不需要验证码'
    };
    buryPoint.event({
      action: 'admin注册弹窗-完成注册',
      eventCategory: 'admin注册弹窗',
      eventLabel: op[type]
    });
  },
  HPCRegisterResult(type) {
    const op = {
      1: '认证码必填',
      2: '认证码选填',
      3: '不需要验证码'
    };
    buryPoint.event({
      action: 'admin注册弹窗-注册结果',
      eventCategory: 'admin注册弹窗',
      eventLabel: op[type]
    });
  },
  OHIToOnehikid() {
    buryPoint.event({
      action: 'admin注册（OneHikID注册）-1.0进入OneHikID注册页',
      eventCategory: 'admin注册（OneHikID注册）'
    });
  },
  OHIToOnehikidJump(type) {
    const op = {
      1: '成功',
      2: '失败'
    };
    buryPoint.event({
      action: 'admin注册（OneHikID注册）-2.0 OneHikID登录成功自动跳转',
      eventCategory: 'admin注册（OneHikID注册）',
      eventLabel: op[type]
    });
  },
  OHIToCompanyInfo() {
    buryPoint.event({
      action: 'admin注册（OneHikID注册）-3.0进入企业信息完善页',
      eventCategory: 'admin注册（OneHikID注册）'
    });
  },
  OHIToPersonInfo() {
    buryPoint.event({
      action: 'admin注册（OneHikID注册）-4.0 进入个人信息完善页',
      eventCategory: 'admin注册（OneHikID注册）'
    });
  },
  OHIRegister() {
    buryPoint.event({
      action: 'admin注册（OneHikID注册）-4.1 提交注册',
      eventCategory: 'admin注册（OneHikID注册）'
    });
  },
  OHIRegisterResult(type) {
    const op = {
      1: '成功',
      2: '失败'
    };
    buryPoint.event({
      action: 'admin注册（OneHikID注册）-5.0 注册结果',
      eventCategory: 'admin注册（OneHikID注册）',
      eventLabel: op[type]
    });
  },
  // 登录接口耗时埋点
  loginTimeCounting(value, type) {
    const op = {
      1: 'HPC',
      2: 'SSO'
    };
    buryPoint.timing({
      action: '登录耗时-登录接口耗时',
      value,
      eventCategory: '登录耗时',
      eventLabel: op[type]
    });
  },
  onLoginToHome(value, eventLabel) {
    console.log('init_onLoginToHome');
    buryPoint.timing({
      name: 'onehikid登录到Home页时长',
      value,
      eventCategory: 'OneHikid登录',
      eventLabel
    });
  }
};
